import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_SALE_TYPES, FETCH_SALE_TYPES_DONE, FETCH_SALE_TYPES_ERROR, FETCH_SALE_TYPES_SUCCESS } from './constants'
import type { SaleType, SaleTypes as SaleTypesState } from './types'

interface ReducerAction extends Action {
  payload: {
    data: SaleType[]
    dateCurrent: RequestDate
    dateCompared?: RequestDate | null
    errorCode?: number
    range: Ranges
  }
}

export default function SaleTypes(state: SaleTypesState = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_SALE_TYPES:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_SALE_TYPES_DONE:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_SALE_TYPES_ERROR:
      return {
        ...state,
        [getDateKey(payload)]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_SALE_TYPES_SUCCESS:
      return {
        ...state,
        [getDateKey(payload)]: {
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
